import { formatMoney } from '@betterment/js-runtime';
import { Button, Dialog, HStack, Heading, Icon, Tag, Text, VStack } from '@betterment/samba-react';

import { DirectTradingCashDialog } from './DirectTradingCashDialog';

import { NarrowTypename } from '../../../../graphql/utils/narrow-typename';
import { EnvelopeAccountTransactionOptionsQuery } from '../graphql/envelopeAccountTransactionOptions.generated';

type DirectTradingAccount = NarrowTypename<EnvelopeAccountTransactionOptionsQuery['account'], 'DirectTradingAccount'>;

export const CashBalanceRow = ({ account }: { account: DirectTradingAccount }) => {
  const { availableBalance, totalBalance, anyPending } = account.cashBalances;

  return (
    <DirectTradingCashDialog availableBalance={availableBalance} totalBalance={totalBalance} anyPending={anyPending}>
      <Dialog.Trigger asChild={true}>
        <Button variant="textSecondary" css={{ width: '100%', textDecoration: 'none' }}>
          <HStack css={{ justifyContent: 'space-between', alignItems: 'center' }}>
            <VStack css={{ gap: 'space.50' }}>
              <Heading variant="title200">Cash balance</Heading>
              {anyPending ? <Tag accent="grey">Pending transactions</Tag> : null}
            </VStack>
            <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
              <Text variant="text100">{formatMoney(totalBalance)}</Text>
              <Icon name="CaretRight" size="small" />
            </HStack>
          </HStack>
        </Button>
      </Dialog.Trigger>
    </DirectTradingCashDialog>
  );
};
